module.exports = __webpack_public_path__ + "img/手持3D数据扫描图.19ec8bfa.png";